import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Comment entered for the entry on the Unassigned Sponsored People report',
    isOptional: true,
    name: 'Unassigned Sponsored People Comment',
    partialId: PartialId.Standard.create('usp_comment'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
